<template>
  <div
    v-show="c_show"
    class="popup-mobile-container"
    :class="{ 'full-height': isFullScreen }"
    :style="{ zIndex: zIndex, height: isFullScreen ? '100%' : '45%' }"
  >
    <v-card
      class="full-width full-height d-flex flex-column overflow-hidden"
      tile
    >
      <v-toolbar
        class="flex-grow-0 draggable-header--text"
        dense
        flat
        short
        color="primary lighten-2"
        dark
      >
        <v-toolbar-title>
          <slot name="title"></slot>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <template v-if="countPopup > 1">
          <v-btn :disabled="isFirst" icon small @click="onToBack()">
            <v-icon small>mdi-arrange-send-backward</v-icon>
          </v-btn>
          <v-btn :disabled="isLast" icon small @click="onToFront()">
            <v-icon small>mdi-arrange-bring-forward</v-icon>
          </v-btn>
        </template>
        <v-btn icon small @click="onFullScreen()">
          <v-icon small>{{
            !isFullScreen
              ? 'mdi-arrow-up-drop-circle-outline'
              : 'mdi-arrow-down-drop-circle-outline'
          }}</v-icon>
        </v-btn>
        <v-btn v-if="!disableClose" icon small @click="onClose">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <div class="flex-grow-1 overflow-auto">
        <slot></slot>
      </div>
    </v-card>
  </div>
</template>

<script>
import ModuleMixin from './draggable-popup.mixin'
export default {
  mixins: [ModuleMixin],
  props: {},
  data: () => ({
    isFullScreen: false,
  }),
  watch: {},
  computed: {},
  methods: {
    onFullScreen() {
      this.isFullScreen = !this.isFullScreen
    },
    onClose() {
      this.c_show = false
    },
  },
}
</script>

<style scoped>
.popup-mobile-container {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
